import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

/* VARIATION BEING USED ON THE GOOGLE PAY, APPLE PAY AND DIGITAL BANKING PAGE */
export const DigitalBankingWrapperStyles = css`
  &.static-digital-banking,
  &.static-digital-banking-overview {
    text-align: center;
  }

  &.static-digital-banking-overview {
    padding: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 3.5rem;
    }
  }
`;

export const DigitalBankingTitleStyles = css`
  ${DigitalBankingWrapperStyles}.static-digital-banking-overview & {
    color: ${themeGet('colors.white')};
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking-overview.esso & {
    color: ${themeGet('colors.main-text')};
  }
`;

export const DigitalBankingIntroStyles = css`
  ${DigitalBankingWrapperStyles}.static-digital-banking & {
    max-width: none;
    color: ${themeGet('colors.main-text')};
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking &,
  .static-digital-banking-overview & {
    margin: 1rem auto 0;
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking-overview & {
    max-width: 640px;
    width: 100%;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking-overview.esso & {
    p {
      font-size: 1.25rem;
      color: ${themeGet('colors.main-text')};
    }
  }
`;

export const DigitalBankingMediaContainerStyles = css`
  ${DigitalBankingWrapperStyles}.static-digital-banking & {
    margin: 0 auto;
    top: 40px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0 auto;
      top: 70px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 0 auto;
      top: 100px;
    }
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking-overview & {
    margin-top: 20px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: 40px;
    }
  }
`;

export const DigitalBankingHeroImageStyles = css`
  ${DigitalBankingWrapperStyles}.static-digital-banking & {
    height: 220px;
    width: 270px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: auto;
      height: 400px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      height: 534px;
    }
  }

  ${DigitalBankingWrapperStyles}.static-digital-banking-overview & {
    height: 220px;
    width: 302px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 100%;
      height: 400px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      height: 534px;
    }
  }
`;
